import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';  
import { userDataReducer, mandateIdReducer, phoneNumberReducer, lanIdReducer, tokenReducer, dateReducer,umrnReducer, dcMandateReducer, softpullDataReducer } from './userSlice';

const persistConfigToken = {
  key: 'token',
  storage,
};

const persistConfigUserData = {
  key: 'userData',
  storage,
};

const persistConfigPhoneNumber = {
  key: 'phoneNumber',
  storage,
};

const persistConfigLanId = {
  key: 'lanId',
  storage, 
};

const persistConfgMandateId = {
  key: 'mandateId',
  storage, 
};

const persistConfgDate = {
  key: 'date',
  storage, 
};

const persistConfgUmrn = {
  key: 'umrn',
  storage, 
};

const persistConfgDcMandateId = {
  key: 'dcMandateId',
  storage, 
};

const persistConfgSoftpullData = {
  key: 'softpullData',
  storage, 
};

const persistedTokenReducer = persistReducer(persistConfigToken, tokenReducer);
const persistedUserDataReducer = persistReducer(persistConfigUserData, userDataReducer);
const persistedPhoneNumberReducer = persistReducer(persistConfigPhoneNumber, phoneNumberReducer);
const persistedLanIdReducer = persistReducer(persistConfigLanId, lanIdReducer);
const persistedMandateIdReducer = persistReducer(persistConfgMandateId, mandateIdReducer);
const persistedDateReducer = persistReducer(persistConfgDate, dateReducer);
const persistedUmrnReducer = persistReducer(persistConfgUmrn, umrnReducer);
const persistedDcMandateIdReducer = persistReducer(persistConfgDcMandateId, dcMandateReducer);
const persistedSoftpullDataReducer = persistReducer(persistConfgSoftpullData, softpullDataReducer);

const store = configureStore({
  reducer: {
    token: persistedTokenReducer,
    userData: persistedUserDataReducer,
    mandateId: persistedMandateIdReducer,
    phoneNumber: persistedPhoneNumberReducer,
    lanId: persistedLanIdReducer,
    date: persistedDateReducer,
    umrn: persistedUmrnReducer,
    dcMandateId: persistedDcMandateIdReducer,
    softpullData: persistedSoftpullDataReducer
  },
  middleware:() => []
});

export const persistor = persistStore(store);

export default store;